import { useContext } from 'react';
import { StorageContext } from 'components/contexts';

/**
 * Retrieve current application web storage
 */
export const useStorage = () => useContext(StorageContext);
